import type { EnrichedVehicleDetails } from '@web/vin-sessions/types';

import { findVehicle } from '../helpers/find-vehicle';
import { useLookup } from './use-lookup';

/**
 * The TechShare vehicle of the given VIN.
 *
 * @param vin - the VIN to look up, or undefined to skip the lookup
 * @returns the vehicle once looked up; undefined without one, while loading, or when the lookup fails
 */
export function useVehicleDetails(vin: string | undefined): EnrichedVehicleDetails | undefined {
    return useLookup(vin, findVehicle);
}
